// extracted by mini-css-extract-plugin
export default {"root":"EmptyFilteredList_root__RRZY+","title":"EmptyFilteredList_title__ZB3S9","button":"EmptyFilteredList_button__W96kJ"};